import {http} from '../util/http'
import {API_KOTLIN_DOMAIN} from '../config'
import headers from './employeeSystemHeader'


export const fetchGrouponList = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/detail`,
    params: {
      clubId: sessionStorage.getItem('club_id'),
    },
  })
}

// 新增团购
export const newGroupon = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon`,
    method: 'post',
    data,
  })
}

// 修改团购
export const editGroupon = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon`,
    method: 'put',
    data,
  })
}

// 删除团购
export const deleteGroupon = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/disabled`,
    method: 'post',
    data,
  })
}

// 获取团购功能开启状态
export const fetchGrouponState = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-club/clubSetting`,
    params,
  })
}

// 提交团购功能开启状态
export const postGrouponState = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-club/clubSetting`,
    method: 'post',
    data,
  })
}

// 获取平台列表
export const fetchPlatformList = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/platform`,
    params,
  })
}

// 团购平台排序
export const orderGrouponList = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/platform/order`,
    method: 'post',
    data,
  })
}

// 重置团购平台排序
export const resetOrderGrouponList = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/platform/order/reset`,
    params,
  })
}

// 新增团购平台
export const newGrouponPlatform = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/platform`,
    method: 'post',
    data,
  })
}

// 修改团购平台
export const editGrouponPlatform = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/platform`,
    method: 'put',
    data,
  })
}

// 删除团购平台
export const removeGrouponPlatform = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/platform/disabled`,
    method: 'post',
    data,
  })
}

/**
 * 修改团购信息
 */
export const editGrouponInfo = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon`,
    method: 'put',
    data,
  })
}

/**
 * 团购和赠品信息
 * @param data {{grouponIds: number[], gifts: {commodity: {name, id: number}, quantity: number, store: {name, id: number}, category: {name, id: number}}[]}}
 */
export const editGrouponGift = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/gift`,
    method: 'post',
    data,
  })
}

/**
 * 增加团购信息
 */
export const addGrouponInfo = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon`,
    method: 'post',
    data,
  })
}

/**
 * 获取仓库列表
 */
export const fetchStoreList = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/store`,
  })
}

/**
 * 获取类型列表
 */
export const fetchCategoryList = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/category`,
    params: {
      clubId: sessionStorage.getItem('club_id'),
    }
  })
}

/**
 * 获取商品列表
 * @param params {{categoryId: string, storeId: string}}
 */
export const fetchCommodityList = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-commodity/commodityListing`,
    params: params,
  })
}

/**
 * 获取球台列表
 */
export const fetchTableList = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/basic?clubId=${sessionStorage.getItem('club_id')}`,
  })
}

/**
 * 更新可用球台
 * @param params {{grouponIds: Array, isEnabledOnAllTables: isAllTable,enabledTableIds: Array}}
 */
export const updateEnableTable = (params) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/table`,
    method: 'post',
    data: params,
  })
}

/**
 * 获取关联平台列表
 */
export const fetchRelationGroupon = (platformId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/platform/deal`,
    params: {
      clubId: sessionStorage.getItem('club_id'),
      platformId
    },
  })
}

/**
 * 绑定团购
 * @param data {{grouponIds: array, deal: Object,platformId: number}}
 */
export const bindShop = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/platform/deal/bind`,
    method: 'post',
    data,
  })
}

/**
 * 解绑团购
 * @param grouponId {number} 团购id
 * @param platformId {number} 平台id
 */
export const fetchUnbind = (grouponId, platformId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/platform/deal/unbind`,
    method: 'post',
    data: {
      grouponIds: [grouponId],
      platformId: platformId
    },
  })
}

/**
 * 查询关联美团团购
 * @param grouponId {number} 团购id
 */
export const fetchMeituanGroupon = (grouponId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/table/groupon/meituan`,
    params: {
      grouponIds: grouponId
    },
  })
}


// WEBPACK FOOTER //
// ./src/api/groupon.js